import React, {PureComponent} from 'react';
import { getJwt } from '../../services/authService';
import http from '../../services/httpService';
import Header from './Header';
import toastr from 'toastr';
import ReactPixel from 'react-facebook-pixel';
import {getCurrentUserId} from '../../services/authService';

const temporaryBearer = process.env.REACT_APP_ENVIRONMENT === 'PROD'?
    'Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJhdWQiOiIyIiwianRpIjoiMDYxOTBhOWI1NWNkY2Q3OTViZmQ2Nzg5Y2UxODYxZmFlNjU3MWE5MDNhZTI5ZTQwYmZkYmRlYmZmZWEyMTE3NzU4ODEyYTVmYTkzY2Q1YmEiLCJpYXQiOjE2MTY0MTYwNzQsIm5iZiI6MTYxNjQxNjA3NCwiZXhwIjoxNjQ3OTUyMDc0LCJzdWIiOiIyNDgiLCJzY29wZXMiOlsiKiJdfQ.er_2b5Q1N2v6zsr40nj5EWm5Mqfs74qx6KXEuhYgfuK9G7ish2kT_tecF_JzE39jFanSgWeqK-ifaAqGeMFg-jKb2Q_ujjsQjNl-dIp6VmtzpIMCvA_bMR7ehVjaP_q5XWhO4iXpdyt3Wn7spvpLsNgSw6VH-DhnS1xdaR0OpoGQO-sM2sJumqxlu1MyxocL2jSAXXxkA6bujueRU-cOZR0o3kNtwm42_i_jfUIZkCNuj8wwcLussVQ4KcAIsUeNZ1hAqo1Pyq7kNDO-Lo5xBIoCSHUOOuTUzZnpWZJWQdoGvuFcjo17lYRrCgxZQI3FGaQ6JSf3YLpZPlHWuh9nPEf3KaY-k6LIoi5mN1dBlmJ7QlLiRt_-QMt1daZu7a34uz2gWPq6gWppB7SQmXa5MX4JVU_pO8P3Nk-CkuXbUsZEksXJLtQveJpm8nIC9OLjLRe0hb9vu9FzbP5VV8IxyHZNul6pt5tHaBn50DjJgxpQTPhVFtyx_aHC3CkvgwKalzghk_FzEc7eq-dA83xyQ8SMgevrm26rJJxvelQZiXVOxtAJbTokqXnyilAkN_AaHuIirg_k0QPHFKLwNI8Z1xcBI9c2qv3XE3iNfrY2WDipes3odOwMllBGPaMXpa6auj-nNukZQOiDbivP3D01G1ErPdiTj9vo-qjC2bKmsQc'
    :
    'Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJhdWQiOiIyIiwianRpIjoiYzg2YjhiMTE5NTM3MTQ5MDgyNWE3NDlhY2VhZGNlZWUzMzQ2NTFmNzg5OTExMGUwMDhhMDJhNDdlZDM0MmEyNGE4ODNiYzNhYjVmYTVhMjEiLCJpYXQiOjE2MTYxNjIzOTgsIm5iZiI6MTYxNjE2MjM5OCwiZXhwIjoxNjQ3Njk4Mzk4LCJzdWIiOiI3NTIiLCJzY29wZXMiOlsiKiJdfQ.O6iyAHJdxwFrY-FD-F7TsV89amuGgkzDUvX0i04oR-V4VQMTXTxjS3h5SzZKXvOr_4kuEtvGvCf4Xx0MaHJ3kyfCiar9GcdwohBeRru-i-UPXcF4LpclMS5b_Gldev6AUyEVw7XxqUzPEssepi9EshOWDe4y8JYt9u8J0k3ogj81LG7GDRCu4cCD9T09bjor6sToQz23Q3GpZKabk5IcGI93X5i1t9J_DUFre4e8dKHt2cFuF7n7QJ6oEgn7u9x5p_ViDrn9ZSGdB9RoYxnpHmwHFZbSiF33PuDX7rnEtv5J_SvUZGl10L0wIIKQenKKNm_IS_zx6e1N-6xINMjeaWoaFrmRJuN7m1GqmbCYGsvHxa4U0SfLdRtzwb-v96iPOPUaV8uRRxtzDQSiWdyJ7ZAIK9DSDkov66lJBatw86bpIF9J0cMca4FBaK-xD516_hywl34wD5olBzgUWbuG19i65UomE1DSTm0Re0ZTbIEQwCvEhev8b_sWp4STt7g_h24fiGMWZFruibCyXslLHGcN_442XVmAG5i0YCs3R_vxAfMG2OU75oAJvbTo-cLV5auX3H76jXGegvkFBrJ6o0Kv9wZ95Q3ff0zVatBFRO7ZiaF-1HKk082eg1JHbTZqbsF1QWPCPWiXCRgtoWecFvs1R5JXSxQSg-7cgvG_Ttg'

export default class CheckoutConfirmation extends PureComponent{
    state = {
        // payment_intent: '',
        // email: '',
        sessionId: '',
        codes: [],
        runOnce: false,
        loader: false
    }
    componentDidMount(){
        if(!getCurrentUserId()){
            this.getLifeTimeCode()
        }


    }

    componentDidUpdate(){
        const search = window.location.search;
        if(search){
            const params = new URLSearchParams(search);
            const sessionId = params.get('session_id') || '';
            const plan = params.get('plan') || '';

            if(sessionId && plan && !this.state.sessionId && !this.state.runOnce){
                this.getLifeTimeCode()
            }
        }


        // try{
        // const result = await http.get('https://api.stripe.com/v1/checkout/sessions/' + sessionId, {headers: {authorization: 'Bearer ' + process.env.REACT_APP_STRIPE_SECRET}});
        // console.log('stripe sesssion result: ', result)
        // const payment_intant = result.data.payment_intent;
        // const email = result.data.customer_details.email;
        // this.setState({payment_intant, email})

    }

    getLifeTimeCode = async () =>{
        await this.setState({runOnce: true})
        const search = await window.location.search;
        // console.log('search: ', search)
        if(search){
            const params = await new URLSearchParams(search);
            // console.log('params: ', params)
            const sessionId = await params.get('session_id') || '';
            const plan = await params.get('plan') || '';
            // console.log('sessionId: ', sessionId)
            if(sessionId && plan && !this.state.sessionId){
                await this.setState({sessionId, loader: true})
                try{
                    const lifeTimeCodeResult = await http.post('api/session_lifetime_code',  {
                        session_id: sessionId,
                        plan
                    } , {headers: {authorization: temporaryBearer}});
                    if(lifeTimeCodeResult.data.codes){
                        await this.setState({
                            codes: lifeTimeCodeResult.data.codes,
                            loader: false
                        })
                        // console.log('Setovao sam state: ', this.state.codes)
                    }
                    if(lifeTimeCodeResult.data.error){
                        toastr.error(lifeTimeCodeResult.data.error)
                        await this.setState({
                            loader: false
                        })
                    }
                    // console.log('paymentIntent result: ', lifeTimeCodeResult.data, lifeTimeCodeResult.data.codes)
                }catch{
                    await this.setState({
                        loader: false
                    })
                    toastr.error('Error with your codes, please reload this page.')
                }
            }
        }
    }

    render(){
        return(
            <div className='onboarding-container'>
                <Header linkDisabled={true}/>
                <div className="onboarding-content">
                    <div className="thank-you-panel">
                        <h1 className="text-align-center">Thank You! <img src="/img/rocket.gif" alt=""/></h1>


                        <h3 className='blue'>Check your inbox for the details!</h3>

                        <p className='normal margin-bottom-30'>Your order was completed successfully.</p><br/>
                        <div className="wrap-container">
                            <div className='half-width'>
                                <h4>Here’s the list of your codes:</h4>
                                <div className='codes-container'>
                                    {this.state.codes.length ?
                                        this.state.codes.map(code=> <span className='code'>{code}</span>)
                                        :
                                        this.state.loader ?
                                            <div className='full-width flex-direction-row flex-middle'>

                                                <img src="/img/chart-loader.svg" alt="Loading..." alt=""/>

                                            </div>
                                            :
                                            ''
                                    }
                                </div>
                            </div>
                            <div className='half-width list-container'>
                                <h4>How to redeem:</h4>
                                <p><span>1</span>Register on <a href="https://app.emitto.io" target='_blank'>app.emitto.io</a></p>
                                <p><span>2</span>Create a new workspace on a <strong>Free Plan</strong></p>
                                <p><span>3</span>Go to <a href="https://app.emitto.io/redeem-code" target='_blank'>app.emitto.io/redeem-code</a></p>
                                <p><span>4</span>Redeem your codes and enjoy! </p>
                            </div>



                            {/*{this.state.codes.length ? <br/> : ''}*/}
                            {/*You can create account or login to existing account at <a target='_blank' href='https://app.emitto.io'>emitto.io</a>.</p>*/}
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}